import React from "react";
import { Button, Paper, TextField, MenuItem, Grid } from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  OBTENER_CATEGORIAS_PERSONAS,
  OBTENER_PERSONAS,
  AGREGAR_PERSONA,
} from "../../../../graphql/personas";

const FrmAgregarPersona = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  const { data, loading } = useQuery(OBTENER_CATEGORIAS_PERSONAS);
  const [agregarPersona] = useMutation(AGREGAR_PERSONA, {
    update(cache, { data: { agregarPersona } }) {
      const { obtenerPersonas } = cache.readQuery({
        query: OBTENER_PERSONAS,
      });
      cache.writeQuery({
        query: OBTENER_PERSONAS,
        data: {
          obtenerPersonas: [...obtenerPersonas, agregarPersona],
        },
      });
    },
  });

  //Para agregar formulario
  const formik = useFormik({
    initialValues: {
      nombre: "",
      apellidos: "",
      CatPersonaId: "",
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required("El nombre es requerido"),
      apellidos: Yup.string().required("Los apellidos son requeridos"),
    }),
    onSubmit: async (inputdata) => {
      try {
        const result = await agregarPersona({
          variables: {
            input: {
              nombre: inputdata.nombre.toUpperCase(),
              apellidos: inputdata.apellidos.toUpperCase(),
              CatPersonaId: inputdata.CatPersonaId,
            },
          },
        });

        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.agregarPersona,
          severity: "success",
        });
        //Si todo sale bien reseteamos el formulario
        formik.resetForm();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };

  if (loading) return <h1>Generando categorías</h1>;
  const { listaCatPersonas } = data;
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12}>
              <TextField
                id="nombre"
                label="Nombre (s)"
                variant="standard"
                value={formik.values.nombre}
                onChange={formik.handleChange}
                fullWidth
              />
              {formik.errors.nombre}
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="apellidos"
                label="Apellidos"
                variant="standard"
                fullWidth
                value={formik.values.apellidos}
                onChange={formik.handleChange}
              />
              {formik.errors.apellidos}
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="CatPersonaId"
                select
                label="Categoría *"
                helperText="Seleccione una categoría para este registro"
                variant="standard"
                fullWidth
                value={formik.values.CatPersonaId}
                onChange={formik.handleChange}
              >
                {listaCatPersonas.map((options) => (
                  <MenuItem key={options.clave} value={options.clave}>
                    {options.categoria}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Paper>
        <Button type="submit">Guardar</Button>
        <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
      </form>
    </>
  );
};

export default FrmAgregarPersona;
